import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { mangaList } from "@/mocks/manga";

const ranked = [...mangaList].sort((a, b) => b.rating - a.rating).slice(0, 5);

const medal = ["ri-medal-fill", "ri-medal-fill", "ri-medal-fill"];

export default function RankSection() {
  const maxRating = ranked[0].rating;
  return (
    <section id="rank" className="bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1fr_1.4fr]">
          <div>
            <SectionHeading
              eyebrow="读者口碑"
              title="本站热门排行"
              desc="依据读者人气与评分综合生成，反映当下最受关注的作品趋势。"
            />
            <div className="mt-6 flex items-center gap-6 rounded-xl border border-background-200 bg-background-50 p-6">
              <div className="flex h-16 w-16 items-center justify-center rounded-full bg-accent-100 text-accent-600">
                <i className="ri-fire-line text-3xl" aria-hidden="true"></i>
              </div>
              <div>
                <p className="font-heading text-lg font-bold text-foreground-950">
                  {ranked[0].title}
                </p>
                <p className="mt-1 text-sm text-foreground-600">
                  评分 {ranked[0].rating} · {ranked[0].followers} 人关注
                </p>
              </div>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-foreground-600">{ranked[0].desc}</p>
            <Link
              to={`/manga/${ranked[0].id}`}
              className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              立即了解
              <i className="ri-arrow-right-line text-sm" aria-hidden="true"></i>
            </Link>
          </div>

          <ol className="space-y-3">
            {ranked.map((m, i) => (
              <li key={m.id}>
                <Link
                  to={`/manga/${m.id}`}
                  className="group flex items-center gap-4 rounded-xl border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-200 hover:bg-background-50"
                >
                  <span
                    className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg font-heading text-base font-bold ${
                      i === 0
                        ? "bg-accent-500 text-background-50"
                        : i === 1
                          ? "bg-primary-200 text-primary-900"
                          : i === 2
                            ? "bg-secondary-200 text-secondary-900"
                            : "bg-background-200 text-foreground-600"
                    }`}
                  >
                    {i + 1}
                  </span>
                  <img
                    src={m.cover}
                    alt={`${m.title}封面缩略图`}
                    className="h-16 w-12 shrink-0 rounded-md object-cover"
                  />
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2">
                      <h3 className="truncate font-heading text-base font-bold text-foreground-950 group-hover:text-primary-700">
                        {m.title}
                      </h3>
                      {i < 3 && (
                        <i
                          className={`${medal[i]} text-base ${
                            i === 0 ? "text-accent-500" : "text-foreground-400"
                          }`}
                          aria-hidden="true"
                        ></i>
                      )}
                    </div>
                    <p className="mt-0.5 text-xs text-foreground-600">
                      {m.genre} · {m.chapters} 话
                    </p>
                  </div>
                  <div className="flex shrink-0 flex-col items-end">
                    <span className="font-heading text-base font-bold text-primary-600">
                      {m.rating}
                    </span>
                    <div className="mt-1 h-1.5 w-16 overflow-hidden rounded-full bg-background-200">
                      <div
                        className="h-full rounded-full bg-accent-500"
                        style={{ width: `${(m.rating / maxRating) * 100}%` }}
                      ></div>
                    </div>
                  </div>
                </Link>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}